module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "m-table",
      {
        'm-table--clickable': _vm.rowClick,
      } ]
  }, [_c('table', {
    staticClass: "m-table__table"
  }, [_c('thead', {
    staticClass: "m-table__head small"
  }, [_c('tr', _vm._l((_vm.columns), function(column, index) {
    return _c('td', {
      key: index,
      class: _vm.getCellClass({
        type: "heading",
        column: column,
        index: index,
      }),
      domProps: {
        "innerHTML": _vm._s(!column.hidden ? column.heading : " ")
      }
    })
  }))]), _vm._v(" "), _c('tbody', {
    staticClass: "m-table__body small"
  }, _vm._l((_vm.rows), function(row, id) {
    return _c('tr', {
      key: id,
      class: [
        "m-table__row",
        "m-table__row--body" ],
      attrs: {
        "title": _vm.getRowTitle(row)
      },
      on: {
        "click": function($event) {
          _vm.onRowClick($event, id, row)
        }
      }
    }, _vm._l((_vm.columns), function(column, index) {
      return _c('td', {
        key: index,
        class: _vm.getCellClass({
          type: "body",
          column: column,
          index: index,
        })
      }, [(typeof(column.value) === "function" && (column.value(row) || {}).is) ? _c(column.value(row).is, _vm._b({
        tag: "component"
      }, 'component', column.value(row).bind || {}, false)) : [_vm._v(_vm._s((typeof(column.value) === "function" ? column.value(row) : column.value) || "-"))]], 2)
    }))
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6a664bc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Table.vue
// module id = 338
// module chunks = 0